import axiosInstance from "../api/axios";

const useCountryLanguages = () => {
  const getCountryLanguages = async (controller, customerScope) => {
    const response = await axiosInstance.get(
      `/get_country/details/${controller}/${customerScope?.toLowerCase()}`,
    );
    const languages = response?.data?.countryDetailsVO?.[0]?.languages || [];
    return (languages || [])
      .slice()
      .sort((a, b) => (a?.priority ?? 0) - (b?.priority ?? 0))
      .map((lang) => ({
        value: lang?.languageCode,
        label: lang?.language,
      }));
  };

  return { getCountryLanguages };
};

export default useCountryLanguages;
